import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit.jsx";
import Foot from "../../../../components/Math/Units/Imperial/Foot.jsx";
import Metre from "../../../../components/Math/Units/Metric/Metre.jsx";
import { NumberFormatText } from "../../../../components/NumberFormatText.jsx";
import { RowBody } from "../../../../components/RowValue/RowBody.jsx";
import { selectInclinedLengthSum } from "../../../../store/slices/fhwaSlice.js";

function InclinedLengthSum() {
  const { t } = useTranslation("translation");

  const inclinedLengthSum = useSelector(selectInclinedLengthSum);

  return (
    <RowBody
      titleValue={<p>{t("aashto.ausser.Length")}</p>}
      inputValue={
        <span className="input">
          <NumberFormatText value={inclinedLengthSum.current} decimalScale={2} />
        </span>
      }
      unitValue={<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />}
    />
  );
}

export default InclinedLengthSum;
